import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../hooks/useAuth';
import './Login.css';

// Active customers/employees can request access even before their first invitation.
const Login = () => {
  const { requestLoginLink } = useAuth();
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [pending, setPending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (pending) return;
    setPending(true);
    setSent(false);
    setError(null);
    try {
      await requestLoginLink(email.trim());
      setSent(true);
    } catch (err) {
      setError(t(err.status === 429 ? 'auth.access.rateLimited' : 'auth.access.requestFailure'));
    } finally {
      setPending(false);
    }
  };

  return <div className="login-container">
    <h1 className="login-title">{t('auth.access.title')}</h1>
    <p className="login-explanation">{t('auth.access.instructions')}</p>
    {sent && <div className="login-alert login-success" role="status">{t('auth.access.sent')}</div>}
    {error && <div className="login-alert" role="alert">{error}</div>}
    <form className="login-form" onSubmit={handleSubmit} aria-busy={pending}>
      <div className="form-group">
        <label htmlFor="email" className="form-label">{t('auth.login.email')}</label>
        <input type="email" id="email" name="email" className="form-input" value={email}
          onChange={(event) => { setEmail(event.target.value); setError(null); setSent(false); }}
          required autoComplete="email" autoCapitalize="none" spellCheck={false} />
      </div>
      <button type="submit" className="submit-button" disabled={pending}>
        {t(pending ? 'auth.access.sending' : 'auth.access.send')}
      </button>
    </form>
    <p className="login-explanation">{t('auth.access.returning')}</p>
    <Link to="/adminlogin" className="forgot-password-link">{t('auth.access.adminLogin')}</Link>
  </div>;
};

export default Login;
